import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ResetPasswordPopup from "./reset-password-popup";
import { routes } from "../../../constants/routes";

const PreneedResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token") || "";

  return (
    <ResetPasswordPopup
      open={true}
      token={token}
      onClose={() => navigate(routes.PRENEED_LOGIN)}
      onSuccess={() => navigate(routes.PRENEED_LOGIN)}
    />
  );
};

export default PreneedResetPasswordPage;
